import { openPageWithoutPending } from '@patsnap/synapse_common_utils'
import { viewDetailConfig } from '@pharmsnap/pharmsnap-web/config/autoComplete'
import { IListItem } from '@pharmsnap/shared/types'
import VueRouter from 'vue-router'

/**
 * pharmsnap通用的autocomplete查看详情回调
 * @param item
 * @param router
 */
export function handleViewDetail(item: IListItem, router: VueRouter) {
  openPageWithoutPending(async () => {
    if (item.itemType) {
      const config = viewDetailConfig[item.itemType]
      if (config) {
        return router.resolve({ name: config.name, params: { [config.paramId]: item.id }, query: { ...(config.query || {}) } }).href
      }
    }
    return ''
  })
}

/**
 * 当前页查看详情
 * @param item
 * @param router
 */
export function handleViewDetailInCurrentPage(item: IListItem, router: VueRouter) {
  if (item.itemType) {
    const config = viewDetailConfig[item.itemType]
    if (config) {
      router.push({
        name: config.name,
        params: { [config.paramId]: item.id },
        query: { ...(config.query || {}) },
      })
    }
  }
}
